<script>
    import merge from 'lodash/merge';
    import Filter from './../Filter';
    import Product from './Product';
    import FilterReset from './FilterReset';
    import {EventBus} from "../../events";
    import noUiSlider from 'nouislider';
    import 'nouislider/dist/nouislider.css';

    export default {
        components: {
            Product,
            FilterReset,
        },
        name: 'sidebar-filters',
        props: {
            initial: {
                required: true,
                type: [Object, Array],
            },
            priceRange: {
                required: true,
                type: Array
            },
            currency: {
                required: true,
                type: String
            },
            redirectTo: {
                required: false,
                type: String,
                default: null,
            },
            isMobile: {
                required: false,
                type: [Boolean, Number],
                default: false,
            },
            defaultRoute: {
                required: false,
                type: String,
            }
        },
        data() {
            return {
                products: {},
                counts: {},
                page: 1,
                price: null,
            }
        },
        methods: {
            /**
             * Only set name and value for special cases like price
             * @param event
             */
            changedFilter(event) {
                let name, value, url;

                if (event.target.dataset.redirect && this.isHidden(event.target.dataset.redirect)) {
                    name = event.target.name;
                    value = event.target.value;

                    let redirect = JSON.parse(event.target.dataset.redirect);

                    if (event.target.checked) {
                        this.filter.addFilter(name, value);
                    } else {
                        this.filter.removeFilterWithValue(name, value);
                    }

                    if (redirect.category !== null) {
                        this.filter.addFilter('category', redirect.category);
                    }

                    url = redirect.route + this.filter.toRawUrlString();
                } else if (event.target.dataset.featureRedirect) {
                    name = event.target.name;
                    value = event.target.value;

                    let featureRedirect = JSON.parse(event.target.dataset.featureRedirect);

                    let alreadySelected = this.filter.getFilter(name);

                    alreadySelected = merge(alreadySelected, [
                        featureRedirect.feature,
                    ]);

                    if (event.target.checked) {
                        this.filter.addFilter(name, value);
                    } else {
                        this.filter.removeFilterWithValue(name, value);
                    }

                    // this.filter.setFilter(name, alreadySelected);

                    url = featureRedirect.route + this.filter.toRawUrlString();
                } else if (event.target.dataset.categoryRedirect) {
                    name = event.target.name;
                    value = event.target.value;

                    let categoryRedirect = JSON.parse(event.target.dataset.categoryRedirect);

                    let alreadySelected = this.filter.getFilter(name);

                    alreadySelected = merge(alreadySelected, [
                        categoryRedirect.category,
                    ]);

                    if (event.target.checked) {
                        this.filter.addFilter(name, value);
                    } else {
                        this.filter.removeFilterWithValue(name, value);
                    }

                    // this.filter.setFilter(name, alreadySelected);
                    url = categoryRedirect.route + this.filter.toRawUrlString();
                } else if (event.type === 'slidestop') {
                    name = 'price';
                    value = this.price.join(':');

                    this.filter.removeFilter(name);

                    if (value !== this.priceRange.join(':')) {
                        this.filter.addFilter(name, value);
                    }
                } else {
                    name = event.target.name;
                    value = event.target.value;

                    if (this.filter.hasFilterWithValue(name, value)) {
                        this.filter.removeFilterWithValue(name, value);
                    } else {
                        this.filter.addFilter(name, value);
                    }
                }

                if (url) {
                    if(this.filterCount === 0){
                        url = this.defaultRoute;
                    }
                    window.location.href = url.toLowerCase();
                    return;
                }

                this.updateFilter();
            },
            changePriceFilter(){
                let name = 'price';
                let value = this.price.join(':');

                this.filter.removeFilter(name);

                if (value !== this.priceRange.join(':')) {
                    this.filter.addFilter(name, value);
                }

                this.updateFilter();
            },
            isHidden(data) {
                if(data) {
                    let redirect = JSON.parse(data);
                    if (redirect.is_hidden) {
                        return true;
                    }
                }
                return false;
            },
            updateFilter(){
                let url = this.filter.toUrlString();

                if (this.redirectTo) {
                    window.location.href = this.redirectTo + url;
                    return;
                }

                if (this.filter.isEmpty()) {
                    url = window.location.href.substr(0, window.location.href.indexOf('?'));
                }

                history.pushState({}, null, url);

                this.$store.dispatch('filter/updated');
            }
        },
        computed: {
            filterCount() {
                return this.filter.count();
            },
            filter() {
                return this.$store.getters['filter/get'];
            },
            priceRangeText() {
                return `min ${this.currencySymbol}${this.price[0] / 100} - max ${this.currencySymbol}${this.price[1] / 100}`;
            },
            currencySymbol() {
                return '€'
            }
        },
        created() {
            this.$store.commit('filter/set', new Filter(this.initial));

            if (this.filter.hasFilter('price')) {
                this.price = this.filter.getFilter('price')[0].split(':');
            } else {
                this.price = this.priceRange;
            }
        },
        mounted() {
            let vue = this;
            let slider = noUiSlider.create(document.getElementById("sliderRange"), {
                start: [this.price[0], this.price[1]],
                connect: true,
                step: 100,
                range: {
                    'min': this.priceRange[0],
                    'max': this.priceRange[1]
                },
            });
            slider.on('slide', function(values){
                vue.price = [values[0], values[1]];
            });
            slider.on('set', function(values){
                vue.changePriceFilter();
            });

            EventBus.$on('filter_updated', () => {
                this.$forceUpdate();

                if (this.isMobile) {
                    setTimeout(() => document.querySelector('.navFilter').click(), 250)
                }
            });
            EventBus.$on('update_counts', (counts) => {
                this.counts = counts;
            });

            // EventBus.$on('filter-change', (event) => {
            //     $("input[type='checkbox']").each(function(i, ele){
            //         $(ele).parent().find("label").attr("disabled", true);
            //         $(ele).attr("disabled", true);
            //         $("#sliderRange").slider({ disabled: true });
            //     });
            // });
            //
            // EventBus.$on('products-updated', (event) => {
            //     $("input[type='checkbox']").each(function(i, ele){
            //         $(ele).parent().find("label").attr("disabled", false);
            //         $(ele).attr("disabled", false);
            //         $("#sliderRange").slider({ disabled: false });
            //     });
            // });
        }
    }
</script>

<style type="text/css">
    .noUi-connect{
        background: #0eaa70 !important;
    }
    .noUi-horizontal{
        height: 10px !important;
    }
    .noUi-handle:before, .noUi-handle:after{
        left: 9px;
        top: 3px;
    }
    .noUi-horizontal .noUi-handle {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        background-image: none;
        background-color: #32aa70;
        top: -5px;
        right: -17px;
    }
    .noUi-horizontal .noUi-handle {
        border: 2px solid white;
    }
    .noUi-handle{
        box-shadow: none;
    }
    .noUi-handle:after {
        left: 15px !important;
    }
    .noUi-handle:after, .noUi-handle:before{
        display: none;
    }
    .noUi-connects {
        border-radius: 6px;
        background-color: #eaeaea;
    }
</style>
